import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import { Quotation } from 'data-layer-cr/dist/models';
import { MessageBox, svgs } from 'design-system';
import selectValidationPaymentEmission from 'src/functions/selectValidationPaymentEmission';

const { mastercard, visa, amex } = svgs;

const useStyles = makeStyles(() => ({
  textStyle: {
    fontSize: '15px',
    fontWeight: 500,
  },
  flexBox: {
    display: 'flex',
    gap: '5px',
  },
}));

type IndividualInformationProps = { quotation: Quotation };

const IndividualInformation = ({
  quotation,
}: IndividualInformationProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Grid item xs={12}>
      <MessageBox
        message={
          <Typography
            className={classes.textStyle}
            data-testid="individual-message-text"
            variant="body2"
          >
            {selectValidationPaymentEmission(quotation)}{' '}
            <Box sx={{ display: 'inline-block' }}>
              <span
                style={{ display: 'flex', gap: '5px', alignItems: 'center' }}
              >
                Aceptamos: <img src={mastercard} alt="mastercard" />
                <img src={visa} alt="visa" /> <img src={amex} alt="amex" />
              </span>
            </Box>
          </Typography>
        }
        hideCloseButton
        variant="info"
      />
    </Grid>
  );
};

export default IndividualInformation;
